import { FC, useEffect, useState } from 'react';
import { Icon }                    from 'View/Common';
import Wrapper                     from './Clock.style';
import { Subject, interval }       from 'rxjs';
import { takeUntil, timeInterval } from 'rxjs/operators';

type TProps = {
  className?: string;
}

export const Clock: FC<TProps> = ({ className = '' }) => {

  const [ date, setDate ] = useState(new Date());

  useEffect(() => {
    const onTick$ = interval(1000);
    const onDestroy$ = new Subject();
    onTick$.pipe(takeUntil(onDestroy$), timeInterval()).subscribe(() => {
      setDate(new Date());
    });
    return () => {
      onDestroy$.next(undefined);
    };
  }, []);

  const strPad = (str: number) => {
    return `${str}`.padStart(2, '0');
  };

  return (
    <Wrapper className={className}>
      <Icon type="clock-circle"/>
      <span>
        {strPad(date.getDate())}.
        {strPad(date.getMonth() + 1)}.
        {strPad(date.getFullYear())}
        <span className="pipe">|</span>
        {strPad(date.getHours())}:
        {strPad(date.getMinutes())}
        &nbsp;Uhr
      </span>
    </Wrapper>
  );

};
